import React, { useRef } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const MessageInput = ({ newMessage, onMessageChange, onSendMessage, isSending }) => {
  const inputRef = useRef(null);

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      onSendMessage(e);
    }
  };

  const handleFileAttach = () => {
    alert('File attachment feature - integrate with Supabase Storage');
  };

  const handleEmojiPicker = () => {
    alert('Emoji picker feature - integrate emoji-picker-react or similar');
  };

  const canSend = newMessage?.trim() && !isSending;

  return (
    <form onSubmit={onSendMessage} className="p-4" style={{ borderTop: '1px solid rgba(255,255,255,0.07)', background: 'rgba(255,255,255,0.02)' }}>
      <div className="flex items-end gap-2">
        {/* Attachment Button */}
        <button
          type="button"
          onClick={handleFileAttach}
          className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-all"
          style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.4)' }}
        >
          <Icon name="Paperclip" size={18} />
        </button>

        {/* Message Input */}
        <div className="flex-1 relative">
          <textarea
            ref={inputRef}
            value={newMessage}
            onChange={(e) => onMessageChange(e?.target?.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type a message..."
            rows={1}
            className="w-full px-4 py-3 pr-12 rounded-xl focus:outline-none resize-none"
            style={{
              minHeight: '44px',
              maxHeight: '128px',
              overflowY: newMessage?.split('\n')?.length > 3 ? 'auto' : 'hidden',
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
              fontFamily: "'Inter', sans-serif",
            }}
          />
          {/* Emoji Button */}
          <button
            type="button"
            onClick={handleEmojiPicker}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 transition-colors"
            style={{ color: 'rgba(255,255,255,0.3)' }}
          >
            <Icon name="Smile" size={18} />
          </button>
        </div>

        {/* Send Button */}
        <button
          type="submit"
          disabled={!canSend}
          className="flex-shrink-0 h-11 w-11 rounded-xl flex items-center justify-center transition-all"
          style={{
            background: canSend ? 'linear-gradient(135deg, #00D4FF, #0099cc)' : 'rgba(255,255,255,0.06)',
            border: canSend ? '1px solid rgba(0,212,255,0.4)' : '1px solid rgba(255,255,255,0.08)',
            color: canSend ? '#0A0A0B' : 'rgba(255,255,255,0.2)',
            boxShadow: canSend ? '0 0 12px rgba(0,212,255,0.3)' : 'none',
            cursor: canSend ? 'pointer' : 'not-allowed',
          }}
        >
          {isSending ? (
            <div className="w-4 h-4 border-2 rounded-full animate-spin" style={{ borderColor: 'rgba(0,0,0,0.2)', borderTopColor: '#0A0A0B' }} />
          ) : (
            <Icon name="Send" size={18} />
          )}
        </button>
      </div>

      {/* Quick Actions */}
      <div className="flex items-center gap-2 mt-2 text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
        <Icon name="Info" size={12} />
        <span>Press Enter to send, Shift+Enter for new line</span>
      </div>
    </form>
  );
};

export default MessageInput;